import type { CallbackAction } from '../../lib/api/operatorConsole';

interface Props {
  action: CallbackAction | string;
}

interface ActionStyle {
  label: string;
  /** Text color. */
  fg: string;
  /** Tint background, derived from the same hue with low alpha. */
  bg: string;
}

// Labels mirror the CALLBACK_DOCS naming (Get Session / Debit / etc.).
// Colors lean on the app palette: success-green for the money-in credit/refund,
// error-red for the money-out debit, brand/muted for the read-only lookups.
const STYLES: Record<string, ActionStyle> = {
  get_session: {
    label: 'Get Session',
    fg: 'var(--co-brand)',
    bg: 'color-mix(in srgb, var(--co-brand) 12%, transparent)',
  },
  get_balance: {
    label: 'Get Balance',
    fg: 'var(--co-muted)',
    bg: 'color-mix(in srgb, var(--co-muted) 14%, transparent)',
  },
  debit: {
    label: 'Debit',
    fg: 'var(--co-error)',
    bg: 'color-mix(in srgb, var(--co-error) 12%, transparent)',
  },
  credit: {
    label: 'Credit',
    fg: 'var(--co-success)',
    bg: 'color-mix(in srgb, var(--co-success) 12%, transparent)',
  },
  refund: {
    label: 'Refund',
    fg: 'var(--co-success)',
    bg: 'color-mix(in srgb, var(--co-success) 12%, transparent)',
  },
  shipping_debit: {
    label: 'Shipping',
    fg: 'var(--co-error)',
    bg: 'color-mix(in srgb, var(--co-error) 12%, transparent)',
  },
  // Shipping Settle carries no money — it confirms fulfillment and closes the
  // round. Brand hue keeps it distinct from the red money-out shipping debit.
  shipping_settle: {
    label: 'Shipping Settle',
    fg: 'var(--co-brand)',
    bg: 'color-mix(in srgb, var(--co-brand) 12%, transparent)',
  },
};

export function ActionBadge({ action }: Props) {
  const style = STYLES[action] ?? {
    label: action,
    fg: 'var(--co-text)',
    bg: 'var(--co-bg)',
  };

  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{ color: style.fg, backgroundColor: style.bg }}
    >
      {style.label}
    </span>
  );
}
